import { render } from "./ContributionCategoryList.vue?vue&type=template&id=b5b677c2&scoped=true"
import script from "./ContributionCategoryList.vue?vue&type=script&lang=js"
export * from "./ContributionCategoryList.vue?vue&type=script&lang=js"

import "./ContributionCategoryList.vue?vue&type=style&index=0&id=b5b677c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b677c2"]])

export default __exports__